define(["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.MFenceConditionDomain = void 0;
    class MFenceConditionDomain {
        static initialise() {
            if (!this.isInitialised) {
                this.isInitialised = true;
                this.values = [
                    { key: MFenceConditionDomain.StockProof, value: "Stock Proof" },
                    { key: MFenceConditionDomain.NotStockProof, value: "Not Stock Proof" },
                    { key: MFenceConditionDomain.NoFencePresent, value: "No Fence Present" }
                ];
                this.KeyIndex = {};
                this.KeyIndex[MFenceConditionDomain.StockProof] = 0;
                this.KeyIndex[MFenceConditionDomain.NotStockProof] = 1;
                this.KeyIndex[MFenceConditionDomain.NoFencePresent] = 2;
                this.ValueIndex = {};
                this.ValueIndex["Stock Proof"] = 0;
                this.ValueIndex["Not Stock Proof"] = 1;
                this.ValueIndex["No Fence Present"] = 2;
            }
        }
        static get Values() {
            this.initialise();
            return this.values;
        }
        static findByValue(value) {
            this.initialise();
            if (this.ValueIndex[value] != null) {
                return this.Values[this.ValueIndex[value]];
            }
            return null;
        }
        static findByKey(key) {
            this.initialise();
            if (this.KeyIndex[key] != null) {
                return this.Values[this.KeyIndex[key]];
            }
            return null;
        }
    }
    exports.MFenceConditionDomain = MFenceConditionDomain;
    Object.defineProperty(MFenceConditionDomain, "StockProof", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "S"
    });
    Object.defineProperty(MFenceConditionDomain, "NotStockProof", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "N"
    });
    Object.defineProperty(MFenceConditionDomain, "NoFencePresent", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: "None"
    });
    Object.defineProperty(MFenceConditionDomain, "isInitialised", {
        enumerable: true,
        configurable: true,
        writable: true,
        value: false
    });
});
